import React from 'react';
import BaseScadaNode from './BaseScadaNode';

export function ScrewConveyorSVG({ value, config = {}, width = 120, height = 36 }) {
    const running = parseFloat(value) >= (parseFloat(config.threshold ?? 0.5));
    const color = running ? (config.run_color || '#22C55E') : (config.stop_color || '#64748B');
    const tubeH = height * 0.55;
    const tubeY = (height - tubeH) / 2;
    const pitch = 18;
    const amplitude = tubeH * 0.35;
    const cy = tubeY + tubeH / 2;

    // Build helicoidal path
    let d = '';
    for (let x = 16; x < width - 14; x += pitch) {
        if (d === '') d = `M ${x},${cy - amplitude}`;
        d += ` Q ${x + pitch / 4},${cy + amplitude} ${x + pitch / 2},${cy - amplitude}`;
        d += ` Q ${x + pitch * 3 / 4},${cy - amplitude * 1.6} ${x + pitch},${cy - amplitude}`;
    }

    return (
        <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} style={{ display: 'block' }}>
            {/* Casing tube */}
            <rect x={8} y={tubeY} width={width - 16} height={tubeH} rx={tubeH / 3} fill="#1E293B" stroke={color} strokeWidth={2} />
            {/* Helix inside */}
            <clipPath id={`screwClip_${width}`}>
                <rect x={10} y={tubeY + 2} width={width - 20} height={tubeH - 4} rx={tubeH / 3} />
            </clipPath>
            <path d={d} stroke={color} strokeWidth={2} fill="none" strokeLinecap="round" clipPath={`url(#screwClip_${width})`} opacity={0.9} />
            {/* Inlet top-left */}
            <rect x={8} y={0} width={14} height={tubeY + 4} rx={3} fill="#1E293B" stroke={color} strokeWidth={1.5} />
            {/* Outlet bottom-right */}
            <rect x={width - 22} y={tubeY + tubeH - 4} width={14} height={height - tubeY - tubeH + 4} rx={3} fill="#1E293B" stroke={color} strokeWidth={1.5} />
            {/* Drive */}
            <rect x={0} y={tubeY + (tubeH - 12) / 2} width={8} height={12} rx={3} fill="#334155" stroke={color} strokeWidth={1.5} />
        </svg>
    );
}

export default function ScrewConveyorNode(props) {
    const { data } = props;
    return (
        <BaseScadaNode {...props}>
            <ScrewConveyorSVG value={data?.liveValue} config={data?.config} width={data?.width || 120} height={data?.height || 36} />
            {data?.label && (
                <div style={{ textAlign: 'center', fontSize: 10, color: '#94A3B8', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                    {data.label}
                </div>
            )}
        </BaseScadaNode>
    );
}
